export default __webpack_public_path__ + "38195f55d29ab37878a24f4bd4a2e9a7.png";